import "../styles/SkeletonLoader.css";

const SkeletonLoader = ({
  lines = 5,
  variant = "article",
  compact = false,
}) => {
  if (variant === "list") {
    return (
      <div
        className={
          compact
            ? "skeleton-list compact"
            : "skeleton-list"
        }
        aria-label="Loading content"
      >
        {Array.from({
          length: lines,
        }).map((_, index) => (
          <div
            className="skeleton-list-row"
            key={index}
          >
            <div className="skeleton skeleton-index" />

            <div className="skeleton-list-copy">
              <div className="skeleton skeleton-line medium" />
              <div className="skeleton skeleton-line short" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (variant === "cards") {
    return (
      <div
        className="skeleton-grid"
        aria-label="Loading content"
      >
        {Array.from({
          length: lines,
        }).map((_, index) => (
          <div
            className="skeleton-block"
            key={index}
          >
            <div className="skeleton skeleton-label" />
            <div className="skeleton skeleton-heading" />
            <div className="skeleton skeleton-line" />
            <div className="skeleton skeleton-line short" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      className={
        compact
          ? "skeleton-wrapper compact"
          : "skeleton-wrapper"
      }
      aria-label="Loading content"
    >
      <div className="skeleton skeleton-label" />
      <div className="skeleton skeleton-title" />

      {Array.from({
        length: lines,
      }).map((_, index) => (
        <div
          key={index}
          className={[
            "skeleton",
            "skeleton-line",
            index === lines - 1
              ? "short"
              : "",
          ]
            .filter(Boolean)
            .join(" ")}
        />
      ))}
    </div>
  );
};

export default SkeletonLoader;